import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import b from 'b_';

import './arrow-link.css';

interface Props {
    className?: string;
    url: string;
    text: string;
}

const class_ = b.with('arrow-link');

export default class ArrowLink extends PureComponent<Props> {
    public render() {
        const { className = '', url, text } = this.props;

        return (
            <Link className={`${class_()} ${className}`} to={url}>
                <span className={class_('circle')} />
                {text}
            </Link>
    );
    }
}
